import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';

import {
  newCheckInAction,
  newNextAction,
  NEW_CHECKIN,
  NEW_NEXT,
} from '../../actions/navigation';

import Button from '../../components/Button';
import Header from '../../components/Header';
import Modal from '../../components/Modal';
import ApplicationId from '../../components/ApplicationId';
import { addLusaHeaderParam, parseUrlParams } from '../../utils/parseUrlParams';
import { formatCurrency } from '../../utils/formatCurrency';

// Configuration & Assets
import { useConfig } from '../../config/ConfigContext';
import './style.scss';
import { ricWorkflowName } from '../../utils/appConstants';

const AgreementSign = (props) => {
  const config = useConfig();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const match = useParams();
  const params = parseUrlParams(window.location.search);
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
  const ricWorkFlow = get(match, 'workflowType') === ricWorkflowName;
  const ricOrLoan = ricWorkFlow ? 'retail installment contract' : 'loan';
  const isInIframe = (window.self !== window.parent);

  const onMessageReceived = (event) => {
    const { data } = event;
    let dataJson;

    try {
      dataJson = JSON.parse(data);
    } catch (e) {
      console.log('not able to parse json', e);
    }

    if (dataJson && dataJson.event === 'session_view.document.completed' && params.key) {
      props.newNextAction({
        workflowType,
        key: params.key,
        data: {
          event: dataJson.event,
          eid: dataJson.data.uuid,
          id: dataJson.applicationId,
          error: null,
        },
        success: () => {
          if (isInIframe) {
            window.top.postMessage({ contractSigned: true }, '*');
          }
        },
      });
    }
  };

  useEffect(() => {
    const iframe = document.getElementById('docusign');
    if (iframe && iframe.contentDocument) {
      const workflowCompleteBtn = iframe.contentDocument.getElementById('workflowComplete');
      if (workflowCompleteBtn) {
        workflowCompleteBtn.addEventListener('click', () => {
          if (params.key) {
            props.newNextAction({
              workflowType,
              key: params.key,
            });
          }
        });
      }
    }

    if (isEmpty(props.checkinData)) {
      props.newCheckInAction({
        workflowType,
        key: params.key,
      });
    }

    window.addEventListener('message', onMessageReceived, false);
    return () => {
      window.removeEventListener('message', onMessageReceived, false);
    };
  }, []);

  useEffect(() => {
    const { fetch, navigate, checkinData } = props;

    if (
      !get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))
      && ((fetch.isDone[`${NEW_CHECKIN}`] && !fetch.isRunning[`${NEW_CHECKIN}`])
      || (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) && !isInIframe)
    ) {
      const dataUrl = get(checkinData, 'data.url', '') || get(checkinData, 'state.url', '');
      let routeUrl = dataUrl.replace(config.hostUrl, '');
      if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl);
      }
      navigate(routeUrl);
    }
  }, [props.checkinData]);

  const handleButtonClick = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className="transition-item wrapper agreement">
      <Header />
      {get(props.checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(props.checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      ) : null}
      <div className="header-btn-wrapper">
        <Button
          className="btn btn-sm header-btn"
          title="Definitions"
          onClick={handleButtonClick}
        />
      </div>
      <div className="content">
        <iframe
          src={get(props.checkinData, ['data', 'data', 'url']) || get(props.checkinData, ['state', 'data', 'url'])}
          title="docusign"
          width="100%"
          height="651px"
          frameBorder="0"
        />
      </div>
      {
        isPopupVisible
        && (
        <Modal>
          <div className="card-content-definition">
            <div className="card-header">
              <h5>Definitions</h5>
            </div>
            <div className="close" onClick={handleClosePopup} />
            <div className="card-content docusign-definition-card">
              <div>
                <b>No Interest on Principal Option Promotion -</b>
                {' '}
                Your
                {' '}
                {ricOrLoan}
                {' '}
                may have a No Interest on Principal Option Promotion included. This promotion can save you money if you pay off the principal amount of the
                {' '}
                {ricOrLoan}
                {' '}
                in full within the Promotional Period (&#34;Promotional Period&#34;). During the Promotional Period you will be responsible for making all of your monthly payments and your
                {' '}
                {ricOrLoan}
                {' '}
                will accrue interest on a monthly basis. If you pay off your
                {' '}
                {ricOrLoan}
                {' '}
                within the Promotional Period, the monthly payments that you have made during this period, which includes accrued interest, will be deducted from the principal amount of the
                {' '}
                {ricOrLoan}
                . Length of Promotional Periods vary, please review your
                {' '}
                {ricWorkFlow ? 'contract' : 'loan agreement'}
                {' '}
                for full details.
              </div>
              <br />
              <div>
                <b>APR - An Annual Percentage Rate (APR)</b>
                {' '}
                is the annual rate charged to borrow funds, inclusive of all fees and charges. LendingUSA calculates APR by combining the Interest Rate and Origination Fees to provide a simple annual rate.
              </div>
              <br />
              <div>
                <b>Origination Fee -</b>
                {' '}
                An origination fee of up to 8% may be included in your
                {' '}
                {ricOrLoan}
                , please review your
                {' '}
                {ricWorkFlow ? 'contract' : 'Loan Agreement'}
                {' '}
                for full details.
              </div>
              <br />
              <div>
                <b>Interest Rate -</b>
                {' '}
                The interest Rate is the percent of principal charged by the
                {' '}
                {ricWorkFlow ? 'Retailer' : 'Lender'}
                {' '}
                for the use of its funds.
              </div>
              <br />
              <div>
                <b>Late Fee -</b>
                {' '}
                A Late Fee of  up to $
                {formatCurrency(get(props.checkinData, ['data', 'data', 'maxLateFee'], 0), 2)}
                {' '}
                will be assessed if you fail to make a payment within 16 days of its scheduled due date.
              </div>
              <br />
              Please call LendingUSA directly with any questions regarding the loan or its terms at
              {' '}
              <b>800-944-6177</b>
              .
            </div>
          </div>
        </Modal>
        )
      }
    </div>
  );
};

AgreementSign.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  newNextAction: PropTypes.func.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(AgreementSign);
